import { useCallback, useEffect, useMemo, useState } from "react";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import {
  DataGrid,
  GridActionsCellItem,
  GridToolbar,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import { Box } from "@mui/material";
import BookIcon from "@mui/icons-material/Book";
import BookmarkAddIcon from "@mui/icons-material/BookmarkAdd";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";

import formatDateTime from "../../../utils/dateFormate";

import { appColors } from "../../../constant/constant";

import { API } from "../../../api/API";
import DeleteDialog from "../modals/DeleteModal";
import DesactivePartenaireModal from "../modals/DesactivePartenaire";
import ProfilPartenaireModal from "../modals/profilPartenaire";
import UpdatePartenaireModal from "../modals/UpdatePartenaire";
import RegisterPartenaire from "../modals/RegisterPartenaire";

// Composant pour la barre d'outils avec un bouton "Ajouter un stagiaire"

// Toolbar component with additional button

const actionTypes = {
  voir: "Voir",
  modifier: "Modifier",
  desactive: "Activer/Desactive",
  delete: "Delete",
};
const iconList = [
  <VisibilityOutlinedIcon sx={{ color: appColors.secondary }} />,
  <TipsAndUpdatesIcon sx={{ color: appColors.secondary }} />,
  <BookIcon sx={{ color: appColors.warning }} />,
  /*<TipsAndUpdatesIcon sx={{ color: appColors.secondary }} />,*/
  <DeleteOutlineOutlinedIcon sx={{ color: appColors.danger }} />,
];
const DataGridPartenaire = () => {
  const [isLoading, setisLoading] = useState(true);
  const [selectedRow, setselectedRow] = useState(null);
  const [pagination, setpagination] = useState({ page: 1, limit: 50 });
  const [showViewModal, setShowModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDesactiveModal, setShowDesactiveModal] = useState(false);

  const handleAction = useCallback((row, actionType) => {
    //row is the row data
    //actionType is the action type : seedetail,  addRapport, addJT
    setselectedRow(row);
    switch (actionType) {
      case actionTypes.voir:
        setShowModal(true);
        break;
      case actionTypes.modifier:
        setShowUpdateModal(true);
        break;

      case actionTypes.desactive:
        setShowDesactiveModal(true);
        break;
      case actionTypes.delete:
        setShowDeleteModal(true);
        break;
      default:
        break;
    }
  }, []);

  /**handleDelete item */

  const handleDeleteConfirm = async () => {
    if (!selectedRow) return;
    try {
      const res = await API.delete(`/stagiaires/${selectedRow.id}`);
      if (res.status === 200 || res.status === 204) {
        handleRefresh();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleDesactiveConfirm = async () => {
    if (!selectedRow) return;
    try {
      await API.patch(`/partenaires/desactivate/${selectedRow.id}`);
      handleRefresh();
    } catch (error) {
      console.log(error.message);
    }
  };

  const columns = useMemo(
    () => [
      {
        field: "order",
        headerName: "#",
        width: 80,
      },
      {
        field: "intitule",
        headerName: "intitule",
        width: 160,
      },
      {
        field: "numero",
        headerName: "numero",
      },

      {
        field: "tel",
        headerName: "tel",
      },
      {
        field: "adresse",
        headerName: "adresse",
      },
      {
        field: "email",
        headerName: "Email",
      },
      {
        field: "type",
      },
      {
        field: "rccm",
        headerName: "rccm",
      },
      {
        field: "ifu",
        headerName: "ifu",
      },
      {
        field: "is_active",
        headerName: "statut",
        type: "boolean",
        renderCell: (params) => {
          return params.value ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                color: "success.main",
              }}
            >
              <TipsAndUpdatesIcon sx={{ marginRight: 1 }} />
              Actif
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                color: "error.main",
              }}
            >
              <DeleteOutlineOutlinedIcon sx={{ marginRight: 1 }} />
              Inactif
            </Box>
          );
        },
      },
      {
        field: "createdAt",
        headerName: "Créé le",
        valueGetter: (value, row) => {
          return formatDateTime(value);
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        type: "actions",
        width: 80,
        disableExport: true,
        getActions: (params) =>
          Object.entries(actionTypes).map((i, index) => {
            return (
              <GridActionsCellItem
                icon={iconList[index]}
                label={`${i[1]}`}
                key={i[0]}
                onClick={() => handleAction(params.row, i[1])}
                showInMenu
              />
            );
          }),
      },
    ],
    [handleAction]
  );

  const [rows, setRows] = useState([]);
  useEffect(() => {
    //fetch data from api
    getSAssure();
  }, []);
  // Fonction de rafraîchissement des données
  const handleRefresh = () => {
    setisLoading(true);
    getSAssure();
  };

  //get stagiaire function from api
  const getSAssure = async () => {
    try {
      const response = await API.get(`/partenaires`);

      if (response.status === 200) {
        const { data } = response.data;
        const _data = data.map((row, index) => ({
          ...row,
          order: index + 1, // Ajouter le numéro d'ordre
        }));
        setRows(_data);
      }
    } catch (error) {
      console.error("Failed to fetch stagiaires:", error);
    } finally {
      setisLoading(false);
    }
  };
  const CustomToolbar = () => (
    <GridToolbarContainer sx={{ backgroundColor: "#f5f5f5", color: "#37B049" }}>
      <GridToolbar
        sx={{
          "& .MuiButton-root": {
            color: "#37B049",
          },
          "& .MuiSvgIcon-root": {
            color: "#37B049",
          },
        }}
      />
      <RegisterPartenaire onRefresh={handleRefresh} />
    </GridToolbarContainer>
  );

  return (
    <Box sx={{ width: "100%" }}>
      <DataGrid
        slots={{
          toolbar: () => <CustomToolbar />,
        }}
        columns={columns}
        rows={rows}
        checkboxSelection
        disableRowSelectionOnClick
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: pagination.limit,
            },
          },
        }}
        pageSizeOptions={[pagination.limit]}
        loading={isLoading}
        slotProps={{
          loadingOverlay: {
            variant: "linear-progress",
            noRowsVariant: "linear-progress",
          },
        }}
      />
      <ProfilPartenaireModal
        show={showViewModal}
        handleClose={() => setShowModal(false)}
        partenaire={selectedRow}
      />
      <UpdatePartenaireModal
        show={showUpdateModal}
        handleClose={() => setShowUpdateModal(false)}
        partenaire={selectedRow}
        onUpdateSuccess={handleRefresh}
      />
      <DesactivePartenaireModal
        show={showDesactiveModal}
        handleClose={() => setShowDesactiveModal(false)}
        handleDesactiveConfirm={handleDesactiveConfirm}
        parteanire={selectedRow}
      />
      <DeleteDialog
        isDeleteDialogOpen={showDeleteModal}
        setIsDeleteDialogOpen={() => setShowDeleteModal(false)}
        handleDeleteConfirm={handleDeleteConfirm}
      />
    </Box>
  );
};

export default DataGridPartenaire;
